function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction, useIsomorphicEffect } from 'hooks';
import * as actions from '../../actions';
import { DATA_SOURCES_TYPE_NAME } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import ConnectDataSourceModal from '../../components/ConnectDataSourceModal';
import ExternalDataSourcesIntro from '../ExternalDataSourcesIntro';
import ExternalDataSource from '../ExternalDataSource';
const ExternalDataSources = ()=>{
    const dataSources = useSelector(selectors.dataSources());
    const connectedDataSources = useSelector(selectors.connectedDataSources);
    const fetchConnectedDataSources = useAction(actions.fetchConnectedDataSources);
    const effect = ()=>{
        if (!connectedDataSources) fetchConnectedDataSources();
    };
    useIsomorphicEffect(effect, []);
    const dataSourcesWithoutCC = dataSources.filter((ds)=>ds.dataSourceProvider !== DATA_SOURCES_TYPE_NAME.CONTOUR_CLOUD);
    if (!dataSourcesWithoutCC.length) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(ExternalDataSourcesIntro, {}),
            /*#__PURE__*/ _jsx("h3", {
                className: "form-label text--uppercase mb-3",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.availablePlatforms))
            }),
            dataSourcesWithoutCC.map((ds)=>/*#__PURE__*/ _jsx(ExternalDataSource, {
                    externalDataSource: ds
                }, ds.externalDataSourceId)),
            /*#__PURE__*/ _jsx(ConnectDataSourceModal, {})
        ]
    });
};
export default ExternalDataSources;
